// reducers/states.js

import { combineReducers } from 'redux';
import { categoryReducer } from './categoryReducer';
import { snackbarsReducer } from './snackbarsReducer';
import { usersReducer } from './usersReducer';
import { authReducer } from './authReducer';
import { jobcoinsPacketReducer } from './jobcoinsPacketReducer';
import { questionsReducer } from './questionsReducer';
import { companyReducer } from './companyReducer';
import { localizationReducer } from './localizationReducer';
import { demandsReducer } from './demandsReducer';
import { reviewsReducer } from './reviewsReducer';
import { whatsappReducer } from './whatsappReducer';  // Certifique-se de ter o caminho correto

export const Reducers = combineReducers({
    categoryState: categoryReducer,
    snackbarState: snackbarsReducer,
    userState: usersReducer,
    authState: authReducer,
    questionState: questionsReducer,
    companyState: companyReducer,
    locationState: localizationReducer,
    demandState: demandsReducer,
    reviewState: reviewsReducer,
    jobcoinsPacketState: jobcoinsPacketReducer,
    whatsappState: whatsappReducer,  // Adicione o reducer do WhatsApp aqui
});
